import { ColumnConfig, ColumnConfigOptions, ColumnText, ConditionalExtractor, DateFormatter, ExtractAndFormatExtractor, LodashExtractor, LodashSeriesEnricherMapper, NumberFormatter, StoreNestedFilterExtractor, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';

import { FAMILY_COLUMN_CONFIG, MODEL_PORTFOLIO_FILTER_FUNCTION } from './family-column.config';

export const HOLDINGS_TABLE_HEADER_V2_COLUMNS = [
	ColumnConfig.create({
		id: 'portfolioId',
		extractor: new LodashExtractor('portfolioId', ''),
		visible: false
	} as ColumnConfigOptions<LodashExtractor>),
	ColumnConfig.create({
		id: 'name',
		extractor: new ConditionalExtractor(
			model => model.managementType === 'research',
			new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
			new LodashExtractor('shortName', '')
		),
		visible: true
	} as ColumnConfigOptions<ConditionalExtractor>),
	ColumnConfig.create({
		id: 'targetAllocation',
		extractor: new ConditionalExtractor(
			model => model.managementType === 'research',
			new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
			new LodashExtractor('shortName', '')
		),
		label: new ColumnText('TARGET_ALLOCATION', 'Target Allocation'),
		visible: true
	} as ColumnConfigOptions<ConditionalExtractor>),
	ColumnConfig.create({
		id: 'latestAllocation',
		extractor: new LodashExtractor('NONEXISTENT_VALUE'),
		label: new ColumnText('LATEST_ALLOCATION', 'Latest Allocation'),
		visible: true
	} as ColumnConfigOptions<LodashExtractor>),
	ColumnConfig.create({
		id: 'compositeFee',
		extractor: new StoreNestedFilterExtractor(
			['familyOverview'],
			'characteristics',
			[
				{ propertyToCompare: 'name', comparedValue: 'expenseRatio', desiredValueExpression: 'total' }
			]
		),
		labelFormatter: new NumberFormatter(),
		visible: true,
		label: new ColumnText('COMPOSITE_FEE', 'Composite Fee')
	} as ColumnConfigOptions<StoreNestedFilterExtractor>),
	ColumnConfig.create({
		id: 'targetAllocationAsOfDate',
		extractor: new LodashExtractor('NONEXISTENT_VALUE'),
		visible: false
	} as ColumnConfigOptions<LodashExtractor>),
	ColumnConfig.create({
		id: 'latestAllocationAsOfDate',
		extractor: new LodashExtractor('analysisDate', ''),
		labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT),
		visible: false
	} as ColumnConfigOptions<LodashExtractor>),
	ColumnConfig.create({
		id: 'compositeFeeAsOfDate',
		extractor: new LodashExtractor('analysisDate', ''),
		labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT),
		visible: false
	} as ColumnConfigOptions<LodashExtractor>),
	ColumnConfig.create({
		id: 'id',
		extractor: new LodashExtractor('id', ''),
		visible: false
	} as ColumnConfigOptions<LodashExtractor>)
];

export const HOLDINGS_TABLE_HEADER_V2 = new TabConfig(
	'holdingsTable.header.v2',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(
			['families', 'familyOverview'],
			['families', 'familyOverview'],
			'families.models',
			(portfolio: any, data: any) => {
				return {
					...portfolio,
					managementType: portfolio?.managementType || data?.families?.managementType,
					...data?.familyOverview?.models?.find(model => model?.id === portfolio.id || model?.id === portfolio.portfolioId) ?? []
				};
			},
			MODEL_PORTFOLIO_FILTER_FUNCTION),
		null,
		HOLDINGS_TABLE_HEADER_V2_COLUMNS,
		FAMILY_COLUMN_CONFIG
	)
);

